/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
 


import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";


// Argon Dashboard 2 MUI examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import Grid from "@mui/material/Grid";

// Data
import EhcTableData from "Views/Activities/Ehc/data/ehcTableData"
import { useState,useEffect } from "react";
import Dropdown from "components/CustomDropdown/Dropdown";
import { Widgets, WidthFull } from "@mui/icons-material";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";

function Tables() {
  const { columns, rows } = EhcTableData;

 const [testStatus, setTestStatus] = useState('');

const handleStatusChange = (event) => {
  setTestStatus(event.target.value);
};

 const tabsData = [
      {label:"All",count:92,color:"#2027e1ff",content:""},
      {label:"Active",count:12,color:"#ec3c10ff",content:""},
      {label:"Hold",count:22,color:"#ec10c7ff",content:""},
      {label:"Completed",count:72,color:"#10a6ecff",content:""},
      {label:"Discontinued",count:88,color:"#1a6808b7",content:""},
      {label:"SME",count:78,color:"#1a6808b7",content:""},
      {label:"Separate Class",count:98,color:"#1a6808b7",content:""},
      {label:"Combined Class",count:21,color:"#1a6808b7",content:""},
    ]

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox  p={3}>
              <ArgonTypography mb={2}  variant="h6" fontWeight="medium" >All EHC</ArgonTypography>
              <ArgonBox display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <ArgonBox sx={{height:"36px"}}>
                  <ApnaTabs tabsData={tabsData} />
                </ArgonBox>

                 <ArgonBox sx={{height:"36px"}} display="flex" alignItems="center" gap={1}>
                  <ArgonTypography variant="caption" fontWeight="regular" sx={{ whiteSpace: "nowrap" }} >Test Status</ArgonTypography>
                  <Dropdown
                   label={""}
                    options={["Conducted", "Not Conducted"]}
                    value={testStatus}
                    onChange={handleStatusChange}
                    width={100}
                  />
  
                 </ArgonBox>

              </ArgonBox>
            </ArgonBox>

            <ArgonBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              <Table columns={columns} rows={rows} />
            </ArgonBox>
          </Card>
        </ArgonBox>
        

      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
